import React, { useContext, useEffect, useState } from "react";
import { assortmentHierarcyContext } from "../context/AssortmentHierarcyContext";

import Tooltip from '@mui/material/Tooltip';
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useTheme } from "@mui/material/styles";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import Button from "@mui/material/Button";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import useLoginfo from "../../utils/useLoginfo";
const searchdata = localStorage.getItem("searchAssortmentvalue")?localStorage.getItem("searchAssortmentvalue"):"";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function createData(
  ASSORTMENT_ID,
  ASSORTMENT_DESC,
  DEPARTMENT,
  AVAILABILITY,
  ASSORTMENT_NBR,
  MIN_SHIP_DATE,
  END_DATE,
  LEAD_TIME,
  FIXED_TIME,
  MAX_SHIP_DATE,
  MARKDOWN,
  DATING,
  START_DATE,
  ACTIVE,
  ADMIN_ONLY,
  SHIP_MONTHS,
  KITTED
) {
  return {
    ASSORTMENT_ID,
    ASSORTMENT_DESC,
    DEPARTMENT,
    AVAILABILITY,
    ASSORTMENT_NBR,
    MIN_SHIP_DATE,
    END_DATE,
    LEAD_TIME,
    FIXED_TIME,
    MAX_SHIP_DATE,
    MARKDOWN,
    DATING,
    START_DATE,
    ACTIVE,
    ADMIN_ONLY,
    SHIP_MONTHS,
    KITTED
  };
}

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  const { deleteAssortmentHierarcyAction } =
    useContext(assortmentHierarcyContext);

  //OKTA
  const { tokenVal } = useLoginfo()

  //delete row
  const handleDelete = (id) => {
    deleteAssortmentHierarcyAction(id, tokenVal);
    // if (id) alert("Assortment deleted");
  };

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.ASSORTMENT_ID}
        </TableCell>
        <TableCell style={{ width: "300px" }}>{row.ASSORTMENT_DESC}</TableCell>
        <TableCell style={{ width: "200px" }}>{row.DEPARTMENT}</TableCell>
        <TableCell style={{ width: "100px" }}>{row.AVAILABILITY}</TableCell>
        <TableCell>{row.ASSORTMENT_NBR}</TableCell>
        <TableCell style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Button
            variant="contained"
            href=""
            onClick={() => handleDelete(row.ASSORTMENT_ID)}
            color="error"
            size="small"
            startIcon={<DeleteIcon />}
            style={{ marginRight: "10px" }}
          >
            Delete
          </Button>
          <Button
            variant="contained"
            href={`/edit-asssortment-hierarcy/${row.ASSORTMENT_ID}`}
            size="small"
            startIcon={<EditIcon />}
          >
            Edit
          </Button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h10" gutterBottom component="div">
                OTHER DETAILS:
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>MIN SHIP DATE</b>
                    </TableCell>
                    <TableCell>
                      <b>MAX SHIP DATE</b>
                    </TableCell>
                    <TableCell>
                      <b>START DATE</b>
                    </TableCell>
                    <TableCell>
                      <b>END DATE</b>
                    </TableCell>
                    <TableCell>
                      <b>LEAD TIME</b>
                    </TableCell>
                    <TableCell>
                      <b>FIXED TIME</b>
                    </TableCell>
                    <TableCell>
                      <b>MARKDOWN</b>
                    </TableCell>
                    <TableCell>
                      <b>DATING</b>
                    </TableCell>
                    <TableCell>
                      <b>ACTIVE</b>
                    </TableCell>
                    <TableCell>
                      <Tooltip title="Y means only visible to admin" arrow><b>ADMIN ONLY</b></Tooltip>
                    </TableCell>
                    <TableCell>
                      <b>SHIP MONTHS</b>
                    </TableCell>
                    <TableCell>
                      <b>KITTED</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow key={row.MARKDOWN}>
                    <TableCell component="th" scope="row">
                      {row.MIN_SHIP_DATE}
                    </TableCell>
                    <TableCell>{row.MAX_SHIP_DATE}</TableCell>
                    <TableCell>{row.START_DATE}</TableCell>
                    <TableCell>{row.END_DATE}</TableCell>
                    <TableCell>{row.LEAD_TIME}</TableCell>
                    <TableCell>{row.FIXED_TIME}</TableCell>
                    <TableCell>{row.MARKDOWN}</TableCell>
                    <TableCell>{row.DATING}</TableCell>
                    <TableCell>{row.ACTIVE}</TableCell>
                    <TableCell>{row.ADMIN_ONLY}</TableCell>
                    <TableCell>{row.SHIP_MONTHS}</TableCell>
                    <TableCell>{row.KITTED}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    DEPARTMENT: PropTypes.string.isRequired,
    ASSORTMENT_DESC: PropTypes.string.isRequired,
    ASSORTMENT_ID: PropTypes.number.isRequired,
    ASSORTMENT_NBR: PropTypes.number.isRequired,
    DATING: PropTypes.number.isRequired,
    END_DATE: PropTypes.string.isRequired,
    START_DATE: PropTypes.string.isRequired,
    MARKDOWN: PropTypes.string.isRequired,
    MAX_SHIP_DATE: PropTypes.string.isRequired,
    MIN_SHIP_DATE: PropTypes.string.isRequired,
    LEAD_TIME: PropTypes.number.isRequired,
    FIXED_TIME: PropTypes.number.isRequired,
    ADMIN_ONLY: PropTypes.string.isRequired,
    ACTIVE: PropTypes.string.isRequired,
    SHIP_MONTHS: PropTypes.string.isRequired,
    KITTED:PropTypes.string.isRequired
  }).isRequired,
};

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "20ch",
    },
  },
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: "ASSORTMENT_ID",
    numeric: false,
    disablePadding: false,
    label: "ASSORTMENT ID",
  },
  {
    id: "ASSORTMENT_DESC",
    numeric: false,
    disablePadding: false,
    label: "ASSORTMENT DESCRIPTION",
  },
  {
    id: "DEPARTMENT",
    numeric: false,
    disablePadding: false,
    label: "DEPARTMENT",
  },
  {
    id: "AVAILABILITY",
    numeric: false,
    disablePadding: false,
    label: "AVAILABILITY",
  },
  {
    id: "ASSORTMENT_NBR",
    numeric: false,
    disablePadding: false,
    label: "ASSORTMENT NUMBER",
  },
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell />
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              <b>{headCell.label}</b>
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell />
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
};

const DefineAssortment = () => {
  const { fetchAssortmentHierarcyAction, assortmentHierarcy } = useContext(
    assortmentHierarcyContext
  );

  //OKTA
  const { tokenVal } = useLoginfo()

  useEffect(() => {
    fetchAssortmentHierarcyAction(tokenVal);
  }, [tokenVal]);
  // console.log(assortmentHierarcy);

  //rows
  const [rows, setrows] = useState(
    assortmentHierarcy.map((item) => {
      return createData(
        item.ASSORTMENT_ID,
        item.ASSORTMENT_DESC,
        item.DEPARTMENT,
        item.AVAILABILITY,
        item.ASSORTMENT_NBR,
        item.MIN_SHIP_DATE,
        item.END_DATE,
        item.LEAD_TIME,
        item.FIXED_TIME,
        item.MAX_SHIP_DATE,
        item.MARKDOWN,
        item.DATING,
        item.START_DATE,
        item.ACTIVE,
        item.ADMIN_ONLY,
        item.SHIP_MONTHS,
        item.KITTED
      );
    })
  );

  useEffect(() => {
    setrows(
      assortmentHierarcy.map((item) => {
        return createData(
          item.ASSORTMENT_ID,
          item.ASSORTMENT_DESC,
          item.DEPARTMENT,
          item.AVAILABILITY,
          item.ASSORTMENT_NBR,
          item.MIN_SHIP_DATE,
          item.END_DATE,
          item.LEAD_TIME,
          item.FIXED_TIME,
          item.MAX_SHIP_DATE,
          item.MARKDOWN,
          item.DATING,
          item.START_DATE,
          item.ACTIVE,
          item.ADMIN_ONLY,
          item.SHIP_MONTHS,
          item.KITTED
        );
      })
    );
    if(searchText !==""){ 
      onHandle(searchText);
    }
  }, [assortmentHierarcy]);

  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("ASSORTMENT_ID");
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [searchText,setSearchText] = React.useState(searchdata);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  const visibleRows = React.useMemo(
    () =>
      stableSort(rows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, rowsPerPage, assortmentHierarcy.length, rows.length]
  );

  const onHandle = (value) => {
    setSearchText(value);
    localStorage.setItem("searchAssortmentvalue",value)
    setrows(
      assortmentHierarcy.filter((i) => {
        return (
          i.ASSORTMENT_ID.toString().includes(value) ||
          i.ASSORTMENT_NBR.toString().includes(value) ||
          i.DEPARTMENT.toLowerCase().includes(value.toLowerCase()) ||
          i.AVAILABILITY.toLowerCase().includes(value.toLowerCase()) ||
          i.ASSORTMENT_DESC.toLowerCase().includes(value.toLowerCase())
        );
      })
    );
    if (value == "") window.location.href = "/asssortment";
  };

  // console.log(rows);
  return (
    <div>
      {/* <Breadcrumbs
        separator="›"
        aria-label="breadcrumb"
        style={{ marginLeft: "15px" }}
      >
        <Link underline="hover" color="inherit" href="">
          Assortment Hierarchy
        </Link>
        <Link
          underline="hover"
          color="text.primary"
          href="/asssortment"
          aria-current="page"
        >
          View Assortment
        </Link>
      </Breadcrumbs> */}

      <h2 style={{ textAlign: "center" }}>View Assortment</h2>

      <div className="add-search">
        <Button
          variant="contained"
          href="/asssortment-hierarcy/add"
          color="success"
          size="large"
          startIcon={<AddIcon />}
        >
          Add Assortment
        </Button>

        <Search style={{ border: "1px solid black" }}>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            onChange={(e) => {
              onHandle(e.target.value);
            }}
            value = {searchText}
            placeholder="SEARCH..."
            inputProps={{ "aria-label": "search" }}
          />
        </Search>
      </div>

      <TableContainer component={Paper} style={{ marginTop: "40px" }}>
        <Table
          sx={{ minWidth: 650 }}
          size="small"
          aria-label="collapsible table"
        >
          <EnhancedTableHead
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
          />
          <TableBody>
            {visibleRows.map((row) => (
              <Row key={row.ASSORTMENT_ID} row={row} />
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[25, 50, 100, { label: "All", value: -1 }]}
                colSpan={7}
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: {
                    "aria-label": "rows per page",
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </div>
  );
};

export default DefineAssortment;
